import styled from 'styled-components'

export const DescriptionText = styled.p`
  font-size: ${({ theme }) => theme.fontSizes[17]}px;
  font-weight: ${({ theme }) => theme.fontWeight[2]};
  line-height: ${({ theme }) => theme.lineHeight[2]}px;
  text-align: justify;

  ${({ theme }) => theme.below.laptop`
    font-size: ${theme.fontSizes[3]}px;
    line-height: ${theme.fontSizes[3]}px;
  `}

  ${({ theme }) => theme.below.mobileL`
    font-size: ${theme.fontSizes[2]}px;
    line-height: ${theme.fontSizes[2]}px;
  `}
`

export const Title = styled.h2`
  font-size: ${({ theme }) => theme.fontSizes[19]}px;
  font-weight: ${({ theme }) => theme.fontWeight[6]};
  line-height: 75px;
  text-transform: uppercase;

  ${({ theme }) => theme.below.laptop`
    font-size: ${theme.fontSizes[5]}px;
    line-height: ${theme.lineHeight[5]}px;
  `}
`

export const ImageWrapper = styled.div`
  position: relative;
`
